(ns frontend.ui.component.lp-portal.modal.style
  (:require
    [common.util :as cu]
    [frontend.utils :as fu]
    [ui.color :as c]))

(defn table
  []
  {:border-collapse "collapse"})

(defn th
  []
  (with-meta
   {:padding "0"}
   {:pseudo {:first-child {:padding    "0.5rem 1rem 0.5625rem"
                           :background "#EDECE7"
                           :border     "1px solid #D9D9DA"}}
    :hover  {}}))

(defn axis-table-th
  []
  (with-meta
    {:padding    "0.5rem 1rem 0.5625rem"
     :background "#EDECE7"
     :border     "1px solid #D9D9DA"}
    {}))

(defn title
  []
  (with-meta
   {:font-weight "bold"}
   {}))

(defn number-input
  []
  (with-meta
   {:padding       "0.5rem 1.8rem 0.5625rem 1.5rem"
    :text-align    "right"
    :border-radius "0"
    :border        "1px solid transparent!important"
    :outline       "none"}
   {:pseudo {:hover {:border "1px solid #38363B!important"}
             :focus {:box-shadow "0 0 0 2px #38363B!important"}}}))

(defn table-cell
  [editable-first-col?]
  (with-meta
   {:padding "1px"
    :border  "1px solid #D9D9DA"}
   {:pseudo {:first-child {:padding "0.5rem 1rem 0.5625rem"
                           :background (when-not editable-first-col? "#EDECE7")
                           }}}))

(defn table-editor-cell
  [editable-first-col?]
  (with-meta
    {:padding "1px"
     :border  "1px solid #D9D9DA"}
    (when editable-first-col? {:pseudo {:first-child {:padding 0
                                                      :background (when-not editable-first-col? "#EDECE7")
                                                      :border "none"}}})))

(defn axis-table-cell
  []
  (with-meta
    {:padding "1px"
     :border  "1px solid #D9D9DA"}
    {}))

(defn full-width
  []
  (with-meta
   {:width "100%"}
   {}))

(defn table-header-input
  [_disabled?]
  (with-meta
   {:flex             "0 0 auto"
    :color            (c/text ::c/input)
    :background-color (str (c/color ::c/input) "!important")
    :min-height       "1.5em"
    :padding          "0.45rem .25rem"
    :text-align       "right"
    :font-weight      "700"
    :outline          "none"
    :border           "1px solid transparent!important"
    :border-radius    "4px"
    :text-overflow "ellipsis"}
   {:pseudo {:hover    {:border-color (str (c/text ::c/input) "!important")}
             :disabled {}
             :focus    {:border-width  "1px"
                        :border-style  "solid"
                        :border-radius "0.25rem"
                        :border-color  (c/text-scale-2 ::c/input)}}}))

(defn cell-dropdown-trigger
  []
  (with-meta
   {:visibility "hidden"}
   {:pseudo {:hover {:color            "#015757"
                     :background-color "#EDECE7"}}}))

(defn cell-dropdown-trigger-span
  []
  (with-meta
   {:padding "2px 6px 2px 6px"}
   {:pseudo {:hover {:color            "#015757"
                     :background-color "#EDECE7"}}}))

(defn table-dropdown-item
  [disabled? rotate? url]
  (with-meta
    {:display "flex"
    :gap     "8px"
    :padding "4px 6px 4px 0px"
    :color   (when disabled? "grey")
    :cursor  (if-not disabled? "pointer" "not-allowed")}
    {:pseudo {:hover {:background-color "#EDECE7"}
             :before {:content    "''"
                      :background-image (when-not (cu/blank-value? url) (str "url('" (fu/sanitize-img-url url) "')"))
                                                                   :transform (when rotate? "rotate(90deg)")
                                                                   :height "30px"
                                                                   :width "30px"
                                                                   :background-repeat "no-repeat"}}}))

(defn table-dropdown-item-no-icon
  [disabled?]
  (with-meta
    {:display "flex"
     :gap     "8px"
     :padding "4px 6px"
     :color   (when disabled? "grey")
     :cursor  (if-not disabled? "pointer" "not-allowed")}
    {:pseudo {:hover {:background-color "#EDECE7"}}}))

(defn remove-icon
  []
  {:padding-left "5px"})

(defn table-header-cell-container
  []
  (with-meta
    {:border "1px solid #D9D9DA"}
    {:combinators {[:descendant "#header-cell:hover span"]
                   {:visibility "visible"}}}))

(defn first-col-cell-container
  []
  (with-meta
    {:border  "none"
     :height "100%"}
    {:combinators {[:descendant "#header-cell:hover span"]
                   {:visibility "visible"}}}))

(defn table-header-cell
  []
  (with-meta
   {:padding         "4px 8px 4px 8px"
    :display         "flex"
    :align-items     "center"
    :justify-content "flex-end"
    :gap             "2px"}
   {}))
